import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import ScrollProgress from '../components/ScrollProgress';
import HeroSection from '../components/HeroSection';
import ProblemSection from '../components/ProblemSection';
import SolutionSection from '../components/SolutionSection';
import FeaturesSection from '../components/FeaturesSection';
import PricingSection from '../components/PricingSection';
import AudienceSection from '../components/AudienceSection';
import PositioningSection from '../components/PositioningSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import ContactFormSection from '../components/ContactFormSection';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/sonner';

export const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.state]);
  return (
    <div className="min-h-screen bg-stone-50 relative">
      <Helmet>
        <title>Practicio — Studio Management for Architects & Designers</title>
        <meta name="description" content="Manage projects, proposals, workplans, and financials — built for architecture and interior design studios." />
        <link rel="canonical" href="https://practicio.io" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "Practicio",
          "applicationCategory": "BusinessApplication",
          "operatingSystem": "Web",
          "description": "Practice management platform built for architects and interior designers in India.",
          "offers": [
            {
              "@type": "Offer",
              "name": "Free",
              "price": "0",
              "priceCurrency": "INR",
              "description": "Try Practicio on a single project"
            },
            {
              "@type": "Offer",
              "name": "Studio",
              "price": "2998",
              "priceCurrency": "INR",
              "billingIncrement": "monthly",
              "description": "Full platform for teams up to 10"
            }
          ]
        })}</script>
      </Helmet>
      {/* Grain texture overlay */}
      <div className="grain-overlay"></div>
      
      <ScrollProgress />
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <FeaturesSection />
        <PricingSection />
        <AudienceSection />
        <PositioningSection />
        <FAQSection />
        <CTASection />
        <ContactFormSection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default LandingPage;